module.exports = __webpack_public_path__ + "media/audios/parent/lesson_3/audio6-5a28432cb3cef104c6a4c465bb5279a6.m4a";